import type { CountryLocalizations, TextLocalization } from '../types';

export const finnishLocalization: TextLocalization = {
  successHeader: 'Maksu onnistui',
  successDescription: 'Valmista! Maksusi onnistui.',
  cancelledHeader: 'Maksu peruutettu',
  cancelledDescription: 'Mitään ei veloitettu. Yritä uudelleen, kun olet valmis.',
  inputPlaceholder: 'Puhelinnumero',
  inputInputLabel: 'Lisää numero maksaaksesi {marketBrandName}lla',
  inputPrimaryLabel: 'Jatka maksamista {marketBrandName}lla',
  useSavedNumberButton: 'Käytä tallennettua {marketBrandName}-numeroani',
  continueAsLabel: 'Jatka käyttäjänä {0}',
  useAnotherNumberLabel: 'Käytä toista numeroa',
  rememberMeLabel: 'Muista numeroni',
  inputPrimary: 'Jatka',
  inputCancel: 'Peruuta maksu',
  inputCancelLabel: 'Peruuta maksu ja palaa verkkokauppaan',
  logoTitle: '{marketBrandName}-logo',
  localeSelectorLabel: 'Valitse kieli, {0} valittu',
  countryCodeSelectorLabel: 'Valitse maakoodi, {0} valittu',
  statusHeader: 'Avaa {marketBrandName}',
  statusAriaLabel:
    'Sinulla on {0} minuuttia ja {1} sekuntia aikaa avata {marketBrandName} ja vahvistaa maksu.',
  statusContent: 'Maksupyyntö on lähetetty numeroon {0}',
  errorHeader: 'Voi ei, jokin meni pieleen',
  errorContent: 'Palaa takaisin ja yritä uudelleen.',
  errorPrimary: 'Takaisin',
  timeoutHeader: 'Voi ei, maksu on vanhentunut',
  timeoutContent: 'Palaa takaisin ja yritä uudelleen.',
  timeoutPrimary: 'Palaa takaisin',
  inputCountryCodeLabel: 'Maakoodi',
  scanToOpenInKlarna: 'Skannaa ja lisää Klarna {marketBrandName}hin',
  addKlarna: 'Lisää Klarna {marketBrandName}hin',
  openVipps: 'Avaa {marketBrandName}',
  openInKlarnaMobileText: 'Puhelimella? Klikkaa tästä',
  inputError:
    'Sinulla tulee olla {marketBrandName} asennettuna puhelimeesi ja sinun tulee olla vähintään 15-vuotias.',
  inputErrorNoEdit: 'Tämä yritys edellyttää, että käytät profiilissasi olevaa puhelinnumeroa.',
  statusNumberFallback: 'puhelinnumerosi.',
  dropDownOptionsLabel: 'Vaihtoehdot',
  qrAltTag: 'QR-koodi maksua varten',
  qrSeparator: 'tai käytä puhelinnumeroasi',
  upgradeApp: 'Näetkö tämän tekstin? Päivitä sovelluksesi.',
  cookieDeclarationText:
    'Käytämme ainoastaan tarvittavia evästeitä siihen, että nettisivumme toimii parhaalla tavalla.',
  cookieDeclarationLink: 'Lue lisää siitä, miten käytämme {cookieDeclaration}.',
  cookieDeclaration: 'evästeitä',
  scanToPay: 'Skannaa ja maksa',
  paymentTo: 'saajalle',
  skipToContent: 'Siirry sisältöön',
  inputHeadingAmount: 'Maksa {0} kauppiaalle {1}',
  inputHeadingRecurring: 'Maksa kauppiaalle {0}',
  inputDescription: 'Kirjoita puhelinnumerosi ja suorita maksu {marketBrandName}ssa.',
  inputDescriptionQr: 'Skannaa QR-koodi ja suorita maksu {marketBrandName}ssa.',
};

export const finnishCountryLocalization: CountryLocalizations = {
  britain: {
    country: '',
    language: 'Englanti',
  },
  norway: {
    country: 'Norja',
    language: 'Norjan',
  },
  denmark: {
    country: 'Tanska',
    language: 'Tanskalainen',
  },
  finland: {
    country: 'Suomi',
    language: 'Suomen',
  },
  sweden: {
    country: 'Ruotsi',
    language: 'Ruotsalainen',
  },
  greenland: {
    country: 'Grönlanti',
    language: 'Englanti',
  },
};
